import { render, staticRenderFns } from "./ConfigurarQuiz.vue?vue&type=template&id=a6966288&scoped=true&"
import script from "./ConfigurarQuiz.vue?vue&type=script&lang=js&"
export * from "./ConfigurarQuiz.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarQuiz.vue?vue&type=style&index=0&id=a6966288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6966288",
  null
  
)

export default component.exports